/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v1.0.0 of "Webapi v2"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class DefaultService {

    /**
     * @returns any Successful response
     * @throws ApiError
     */
    public static postEventsExternalIdentifiers({
        requestBody,
    }: {
        requestBody: {
            identifier: string | null;
        }
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postEventsExternalIdentifiers({
        requestBody,
    }: {
        requestBody: {
            identifier: string | null;
        }
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<{
        identifier: string;
        dcId?: string | null;
        adFormId?: string | null;
        facebookId?: string | null;
        exponeaId?: string | null;
        genesysId?: string | null;
        googleGid?: string | null;
        conversionId?: string | null;
    }>;
    public static postEventsExternalIdentifiers({
        requestBody
    }: {
        requestBody: {
            identifier: string | null;
        },
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/events/externalIdentifiers',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
